export const name = "ST_ENDPOINT";
export const summary = `Gets the last point of a linestring \`GEOGRAPHY\` value.`;
export const reference = `
## ST_ENDPOINT

Gets the last point of a linestring \`GEOGRAPHY\` value.

\`\`\`
ST_ENDPOINT(linestring_geography)
\`\`\`

### Description

Returns the last point of a linestring geography as a point geography. Returns an error if the input isn't a linestring or if the input is empty. Use the\`SAFE\` prefix to obtain \`NULL\` for invalid input instead of an error.


### Return Type

Point \`GEOGRAPHY\`


### Example



\`\`\`
SELECT ST_ENDPOINT(ST_GEOGFROMTEXT('LINESTRING(1 1, 2 1, 3 2, 3 3)')) last

/*--------------*
 | last |
 +--------------+
 | POINT(3 3) |
 *--------------*/
\`\`\`


source: https://cloud.google.com/bigquery/docs/reference/standard-sql/geography_functions
`;
